// App.js
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import { Navbar } from './components'
// import { Chatbot } from './components' // Temporarily disabled
import Home from './Home';
import { usePageTracking } from './hooks/usePageTracking';

import { Footer } from './containers'
import DownloadRedirect from './DownloadRedirect';

// Route-level code splitting — each chunk loads only when its route is visited
const Faq = React.lazy(() => import('./containers/faq/Faq'));
const BlogList = React.lazy(() => import('./containers/blog/BlogList'));
const BlogPage = React.lazy(() => import('./containers/blog/BlogPage'));
const PartnerPage = React.lazy(() => import('./containers/partner/PartnerPage'));
const Legal = React.lazy(() => import('./Legal'));
const Privacy = React.lazy(() => import('./Privacy'));
const About = React.lazy(() => import('./About'));
const Booking = React.lazy(() => import('./containers/booking/Booking'));
const HomeInspectionPune = React.lazy(() => import('./HomeInspectionPune'));
const HomeInspectionMumbai = React.lazy(() => import('./HomeInspectionMumbai'));
const HomeInspectionBangalore = React.lazy(() => import('./HomeInspectionBangalore'));
const HomeInspectionChennai = React.lazy(() => import('./HomeInspectionChennai'));
const InspectionToolsPage = React.lazy(() => import('./InspectionToolsPage'));
const HomeInspectionChecklistPage = React.lazy(() => import('./HomeInspectionChecklist'));
const InspectorAppPage = React.lazy(() => import('./containers/inspectorapp/InspectorAppPage'));
const PaymentsPage = React.lazy(() => import('./containers/payments/PaymentsPage'));
const HiddenDefectsLanding = React.lazy(() => import('./containers/hiddendefects/HiddenDefectsLanding'));
const VideoDemoLanding = React.lazy(() => import('./containers/videodemo/VideoDemoLanding'));
const ThermalInspectionLanding = React.lazy(() => import('./containers/thermalinspection/ThermalInspectionLanding'));
const DampnessInspectionLanding = React.lazy(() => import('./containers/dampnessinspection/DampnessInspectionLanding'));
const ServiceLandingPage = React.lazy(() => import('./containers/servicelanding/ServiceLandingPage'));
const CareersPage = React.lazy(() => import('./containers/careers/CareersPage'));
const HomeInspectionLonavala = React.lazy(() => import('./containers/lonavala/HomeInspectionLonavala'));
const NpsFeedbackPage = React.lazy(() => import('./containers/nps/NpsFeedbackPage'));

const SERVICE_SLUG_MAP = {
  'Dampness Inspection': 'dampness-inspection',
  'Electrical Inspection': 'electrical-inspection',
  'Plumbing Inspection': 'plumbing-inspection',
  'Walls & Flooring Inspection': 'walls-flooring-inspection',
  'Doors & Windows Inspection': 'doors-windows-inspection',
  'RERA Carpet Area Verification': 'rera-carpet-area-verification',
};

const ServiceRedirect = () => {
  const { serviceName } = useParams();
  const slug = SERVICE_SLUG_MAP[decodeURIComponent(serviceName)];
  return <Navigate to={slug ? `/${slug}` : '/'} replace />;
};

const AppContent = () => {
  // Track page views on route changes
  usePageTracking();

  return (
    <>
      <div className='App'>
        <div className='gradient__bg'>
          <Navbar />
        </div>
        {/* <Chatbot /> Temporarily disabled */}
      </div>
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home-inspection-faq" element={<Faq />} />
          <Route path="/legal-property-services" element={<Legal />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPage />} />
          <Route path="/become-a-partner" element={<PartnerPage />} />
          <Route path="/book-inspection" element={<Booking />} />
          <Route path="/home-inspection-pune" element={<HomeInspectionPune />} />
          <Route path="/home-inspection-mumbai" element={<HomeInspectionMumbai />} />
          <Route path="/home-inspection-bangalore" element={<HomeInspectionBangalore />} />
          <Route path="/home-inspection-chennai" element={<HomeInspectionChennai />} />
          <Route path="/home-inspection-tools" element={<InspectionToolsPage />} />
          <Route path="/home-inspection-checklist" element={<HomeInspectionChecklistPage />} />
          <Route path="/home-inspection-inspector-app" element={<InspectorAppPage />} />
          <Route path="/common-hidden-defects-during-home-inspection" element={<HiddenDefectsLanding />} />
          <Route path="/professional-home-inspection-demo" element={<VideoDemoLanding />} />
          <Route path="/thermal-inspection" element={<ThermalInspectionLanding />} />
          <Route path="/dampness-inspection" element={<DampnessInspectionLanding />} />
          <Route path="/electrical-inspection" element={<ServiceLandingPage />} />
          <Route path="/plumbing-inspection" element={<ServiceLandingPage />} />
          <Route path="/walls-flooring-inspection" element={<ServiceLandingPage />} />
          <Route path="/doors-windows-inspection" element={<ServiceLandingPage />} />
          <Route path="/rera-carpet-area-verification" element={<ServiceLandingPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/home-inspection-lonavala" element={<HomeInspectionLonavala />} />
          <Route path="/service/:serviceName" element={<ServiceRedirect />} />
          <Route
            path="/thermal-inspection-mumbai-pune"
            element={<Navigate to="/thermal-inspection" replace />}
          />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/nps-feedback" element={<NpsFeedbackPage />} />
          <Route path="/dl/:shortId" element={<DownloadRedirect />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
